<template>
  <div class="smd-options">

    <smd-btn v-if="icon"
             bg :icon="icon"
             key="notitle"
             @click.stop='tryShowList'>
    </smd-btn>

    <smd-btn v-if="title"
             v-bind="attrs"
             :key="title"
             @click.stop='tryShowList'>
      {{title}}
      <span class="normal" v-if="subtitle">{{subtitle}}</span> <span>&#9662;</span>
    </smd-btn>

    <smd-btn v-if="!title && !icon"
            :icon="'smd-icon-action-more-horizontal'"
            key="notitle"
            :class="{dark: showList, bordered: buttonText}"
            @click.stop="tryShowList">
    </smd-btn>

    <span v-if="buttonText">{{buttonText}}</span>

    <smd-aileron :open-position="openPosition" v-model="showList">
      <div class='smd-options__container'>
        <div class="smd-options__item"
             v-bind='item'
             v-for="item in items"
             :key="item.id"
             :class="item.class"
             @click.stop='selected(item)'>
          <span v-if='item.icon' :class='`smd-icon-${item.icon}`'></span>
          <span v-if="item.label">{{item.label}}</span>
          <i v-if="item.subText">{{item.subText}}</i>
        </div>
      </div>
    </smd-aileron>

  </div>
</template>

<script>

  export default {
    name: 'smd-options',
    props: {
      custom       : {type: Boolean, default: false},
      disabled     : {type: Boolean, default: false},
      icon         : String,
      items        : Array,
      subtitle     : String,
      title        : String,
      buttonText   : String,
      openPosition : {type: String, default: 'bottom'}
    },
    data() {
      return {
        showList: false,
      };
    },
    computed:{
      attrs(){
        if(JSON.stringify(this.$attrs) != "{}"){return {...this.$attrs};}
        else{return {'clean' : ""};}
      }
    },
    methods: {
      selected(item) {
        this.showList = false;
        this.$emit('item-selected', item);
      },
      tryShowList() {
        if(!this.disabled && !this.showList) {
          this.showList = true;
        }
      }
    },
  }
</script>

<style lang="scss">
  @import 'scss/pogs-util';

  .smd-options{
    @extend %flex-row--center-x;
    position: relative;

    button + span{
      @include space-me($l: s);
      font-weight: font(medium-bold);
    }
  }

  .smd-options__container {
    @extend %hide-overflow;
  }

  .smd-options__item {
    @include space-me($t:s,$b:s,$r:m,$l:m);
    @include font-style(base);
    @extend %flex-row--center-x;

    cursor: pointer;

    font-weight: font(medium-bold);

    white-space: nowrap;
    user-select: none;

    &:hover{
      background: color(hover);
    }

    i{
      padding-left: space(xs);
    }

    [class^='smd-icon-']{
      @include space-me($prop: margin, $r: s);
      &:before{
        color: color(label);
        position: relative;
        top: -2px;
      }
    }
  }
</style>